import dynamic from "next/dynamic";

import React from "react";

import { Entity } from "models/entity";
import { twMerge } from "tailwind-merge";

const ComparisonChartSection = dynamic(
  () => import("./ComparisonChartSection"),
  {
    ssr: false,
  }
);

interface PriceTargetProps {
  entity: Entity;
}

const PriceTarget = ({ entity }: PriceTargetProps) => {
  return (
    <div>
      <div
        className={twMerge(
          "pb-[10px]",
          "font-medium",
          "text-[16px]",
          "text-[#1f1f20]",
          "text-center"
        )}
      >
        Consensus Price Target History
      </div>
      <ComparisonChartSection entity={entity} />
    </div>
  );
};

export default PriceTarget;
